export default __webpack_public_path__ + "static/PBSA-d4ec73f6dfa479debaa1141d2d476382.svg";